export const Source: unique symbol = Symbol("Source");
export type Source = typeof Source;
export const Sink: unique symbol = Symbol("Sink");
export type Sink = typeof Sink;
export const None: unique symbol = Symbol("None");
export type None = typeof None;
